import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as SETAPI from 'cd-eft/services/eftSetApi';

const libraryStore = stores.AppStore.projectsLibraryStore;

export class ActivitySummaryVM {
  @observable props;
  @observable projectId: string;
  @observable activitySummary: any = [];
  constructor(props) {
    this.props = props;
    this.projectId = this.props.projectId;
  }

  @action.bound async getActivitySummary(projectId) {
    libraryStore.incrementLoading();

    try {
      const response = await SETAPI.ActivityLogController.getActivitySummaryByProjectUuidUsingGET(projectId);
      this.activitySummary = response.data;
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      libraryStore.decrementLoading();
    }
  }
}